const state = {
  availResponse: {},
  sampleHotelData: {
    "id": "700031341",
    "id_t": "50563",
    "name": "Planet Hollywood Resort And Casino",
    "hotel_zone": "LV Strip - Central West",
    "zone_rank": "",
    "hotel_description": "Located on the Las Vegas Strip, this modern hotel and casino features a full-service spa and 9 on-site restaurants. The Miracle Mile Shops, with over 170 upscale stores, 15 restaurants and 3 live theaters, are directly connected to the hotel. Planet Hollywood features 2 outdoor swimming pools and hot tubs that overlook the Strip. Guests can use the fitness center or browse the on-site shops. Evening entertainment from world-class performers is also available. The luxurious guest rooms at the Planet Hollywood Las Vegas are equipped with 42-inch plasma-screen TVs. Spacious bathrooms and movie memorabilia are also included in each room. Dining options include BurGR, celebrity chef Gordon Ramsay's casual American restaurant as well as the Strip House, a classic American steakhouse. Koi offers Japanese cuisine while the famous Pink's Hot Dogs serves American hot dog specialties. A buffet and other casual dining options are also available. The Las Vegas Convention Center is 8 minutes' drive away.",
    "star_rating": 4,
    "review_rating": 8.04,
    "review_rating_desc": "Very Good",
    "thumbnail": "//mobileimg.priceline.com/htlimg/50/50563/thumbnail-150-square.jpg",
    "thumbnail_hq": {
        "hundred_fifty_square": "//mobileimg.priceline.com/htlimg/50/50563/thumbnail-150.jpg",
        "three_hundred_square": "//mobileimg.priceline.com/htlimg/50/50563/thumbnail-300.jpg"
    },
    "city": {
        "id": "800049030",
        "name": "Las Vegas"
    },
    "address": {
        "city_name": "Las Vegas",
        "address_line_one": "3667 Las Vegas Boulevard South",
        "state_code": "NV",
        "state_name": "Nevada",
        "country_code": "US",
        "country_name": "United States",
        "zip": "89109"
    },
    "geo": {
        "latitude": "36.111001",
        "longitude": "-115.1728"
    },
    "neighborhood": null,
    "hotel_chain": {
        "id": 233,
        "group_id": null,
        "name": "Harrahs Entertainment",
        "code": 233,
        "chain_codes_b": "1932",
        "chain_codes_t": "HR"
    },
    "amenity_data": [
        {
            "id": "2",
            "name": "Business Center"
        },
        {
            "id": "3",
            "name": "Casino"
        },
        {
            "id": "9",
            "name": "Fitness Center or Spa"
        },
        {
            "id": "11",
            "name": "Accessible"
        },
        {
            "id": "12",
            "name": "No Smoking Rooms/Facilities"
        },
        {
            "id": "14",
            "name": "Restaurant"
        },
        {
            "id": "15",
            "name": "Swimming Pool"
        },
        {
            "id": "17",
            "name": "Garden"
        },
        {
            "id": "18",
            "name": "Golf Course"
        },
        {
            "id": "20",
            "name": "Laundry"
        },
        {
            "id": "21",
            "name": "Meeting/Banquet Facilities"
        },
        {
            "id": "22",
            "name": "Newspapers"
        },
        {
            "id": "25",
            "name": "Valet Parking"
        },
        {
            "id": "26",
            "name": "Room Service"
        },
        {
            "id": "28",
            "name": "Sauna"
        },
        {
            "id": "29",
            "name": "Shops in Hotel"
        },
        {
            "id": "34",
            "name": "Terrace"
        },
        {
            "id": "35",
            "name": "Tour Desk"
        },
        {
            "id": "38",
            "name": "Air Conditioning"
        },
        {
            "id": "40",
            "name": "Bar"
        },
        {
            "id": "45",
            "name": "Concierge Service"
        },
        {
            "id": "49",
            "name": "24hr room service"
        },
        {
            "id": "51",
            "name": "Elevator"
        },
        {
            "id": "53",
            "name": "Nightclub"
        },
        {
            "id": "55",
            "name": "Inhouse movies"
        },
        {
            "id": "56",
            "name": "Hair dryer"
        },
        {
            "id": "57",
            "name": "Bathtub"
        },
        {
            "id": "58",
            "name": "Shower"
        },
        {
            "id": "62",
            "name": "Massage"
        },
        {
            "id": "82",
            "name": "salon"
        },
        {
            "id": "83",
            "name": "bathrobes"
        },
        {
            "id": "84",
            "name": "desk"
        },
        {
            "id": "85",
            "name": "in room safe"
        },
        {
            "id": "88",
            "name": "complimentary bottled water"
        },
        {
            "id": "89",
            "name": "private pool"
        },
        {
            "id": "113",
            "name": "Heating"
        },
        {
            "id": "170",
            "name": "internet access – LAN"
        },
        {
            "id": "171",
            "name": "ironing facilities"
        },
        {
            "id": "172",
            "name": "television"
        },
        {
            "id": "173",
            "name": "television LCD/plasma screen"
        },
        {
            "id": "174",
            "name": "separate shower and tub"
        },
        {
            "id": "175",
            "name": "mini bar"
        },
        {
            "id": "176",
            "name": "satellite/cable TV"
        },
        {
            "id": "177",
            "name": "in room video games"
        },
        {
            "id": "178",
            "name": "pool (kids)"
        },
        {
            "id": "180",
            "name": "fitness center"
        },
        {
            "id": "181",
            "name": "steamroom"
        },
        {
            "id": "184",
            "name": "poolside bar"
        },
        {
            "id": "185",
            "name": "internet access – wireless (charges apply)"
        },
        {
            "id": "187",
            "name": "car park"
        },
        {
            "id": "191",
            "name": "seating area"
        },
        {
            "id": "267",
            "name": "Balcony/Terrace"
        },
        {
            "id": "526",
            "name": "Golf Course (On Site)"
        },
        {
            "id": "723",
            "name": "Outdoor pool"
        },
        {
            "id": "1564",
            "name": "Visa"
        },
        {
            "id": "1565",
            "name": "MasterCard"
        },
        {
            "id": "1566",
            "name": "American Express"
        },
        {
            "id": "1603",
            "name": "Diners Club"
        },
        {
            "id": "1604",
            "name": "Discover Card"
        },
        {
            "id": "2179",
            "name": "Car Park - On Site,Free"
        },
        {
            "id": "2277",
            "name": "Towels"
        }
    ],
    "room_data": [
        {
            "id": "ZD3-nJFVfPFPpFpqBYvJDA",
            "rate_data": [
                {
                    "source": "PPN",
                    "rate_type": "MER",
                    "commission_type": "COMMISSION",
                    "distribution_type": "PUBLIC",
                    "payment_type": "PREPAID",
                    "board_type": "NONE",
                    "inventory_type": "PCLN",
                    "program_types": [],
                    "title": "Ultra Hip with King Bed - Non-Smoking",
                    "description": "Ultra Hip with King Bed - Non-Smoking.",
                    "occupancy_limit": 2,
                    "available_rooms": 50,
                    "room_sq_footage": null,
                    "ppn_bundle": "HER_vvC_4r-taiyFBkYSLnn4jn3NAT0hjkXIey6JU05To4Nl3zf2gwv-DcCPOmnU3K9lKetWc62EvAa0j6zrngPRxLjWoCGypugOfHa7HgFVgc6ELFhhgPdg690MwQbSjKJ0PShOKsJx42oHylMsGjCBFPGoVCRNJADtPTdX97Kn9sWbbThEe_JLLFtOD3hTwbsdZ3Mc_89O03rusNGo9H3tNlLPI46eqeSuAKvZsWhZOfJyw8wdQgZAmZmQu9KYh4zJ5DQVdr4eODqcCv9GBbXkGoSPAufjp3BlwQYdRBNNP7BOyT34kiE2psrrWnhHh5uf7je4ur8VlQKvzCfOpQqvGbS82gqsXfhQKclNPSDCmdtU-Ulzg5iZeC0rKvIy8UaqI3SV67OSF_p7kNuLvFFyVsCAvNSy0cIy74rvXnj4ay2V-IAjIUF7IDCrt9QsdcQVhStaSpCufpSG6nXr-0JDcBpUqpBPmkgzgEfrHdIf6-Np1AjzDfBwEP-nCI6deEmnHsEC0COOVvLTiqcAQqfGADBEcdj2N_PlSXJSjmYZFf-6wXKMhdMTUWVkbtQ7nbmM3e-x7Kuegy7OfxvP-u0ebOjtSg0FI8Y8gj9MP7lsCVLzytw8fTCr93LzGSJRh-awUfrhnfjVXpgNKa-qw2jWyMfmfFQvzng5ubEg_yGi5Dv4NVAxIJrzlKFxk9mahNXDTe-OBRgaePLUhrU9dmXgNuEZ2UlyrKsEJQSJktQ-wyOABNL3qEfeC61eFvrQdB_Ht579kTMqYEBBo32Snm-q6HRJmSCDi-IdI-x3yqdVEettR3DIRwzOhLMu_hJp7WGpIyKhHOt93y-VTbN2n0fk2QyvyqApoxAOTy8EK4OumYhzZaz3jZecNmv9wYtr51HQ_K9_D3wQKlaNr3v8mVo-EmDnOYMwOaPeE6UJghiMM3AtYBP9xkb9ofRvcjJ_koCJ4-ULX1K2YR2S25xHtJA_na3iND1sPb1r_QAxaEq5SVO08bQSO1_tX07lZs2Y_CKL5HE9wjup0yBYlF0ny1JT_id2VKoG_thPDzcyS7NgOFvXVJ7LvlMwfPix9v9loPq0N9M_FKucWdJwTAOzWU9JR08l_Koz4R9G2Qp_tLO9G1fsYhKhlJkP8rYe6la-gpN4vDbwqF8bc1bHqH5LcggbMBPgNHtqJra7nqs4xgrD7M_O6QItqAI-F_VyKnSVKj-L",
                    "rate_plan_code": "1484996_MERCHANT_MERCHANT__5f127fc5-ad06-3eba-d295-7677bcbb4a0b",
                    "rate_tracking_id": "16BCF9699BD28C1A1FCA74DF3FF78BC9ABBEE444F5FA10A69230E464D30256086DE53B64368585C7C2E841AF77628B3E852C1191FF93A428A64EB1400C8D913FE2296377702BF864EB0BD5603249DBA025F0009BFF61214B",
                    "all_inclusive": "false",
                    "bed_choice_available": false,
                    "rate_source_code": 9,
                    "bedding_data": null,
                    "benchmark_price_details": {
                        "saving_percentage": 0,
                        "baseline_currency": "USD",
                        "baseline_price": 70.69,
                        "source_currency": "USD",
                        "source_price": 70.69,
                        "display_currency": "CAD",
                        "display_price": 95.9
                    },
                    "property_fee_details": null,
                    "price_details": {
                        "baseline_currency": "USD",
                        "baseline_price": 70.69,
                        "baseline_symbol": "$",
                        "baseline_processing_fee": 0,
                        "baseline_insurance_fee": 0,
                        "baseline_sub_total": 494.82,
                        "baseline_taxes": 67.82,
                        "baseline_total": 562.62,
                        "source_currency": "USD",
                        "source_price": 70.69,
                        "source_symbol": "$",
                        "source_processing_fee": 0,
                        "source_insurance_fee": 0,
                        "source_sub_total": 494.82,
                        "source_taxes": 67.82,
                        "source_total": 562.62,
                        "display_currency": "CAD",
                        "display_price": 95.9,
                        "display_symbol": "$",
                        "display_processing_fee": 0,
                        "display_insurance_fee": 0,
                        "display_sub_total": 671.3,
                        "display_taxes": 91.98,
                        "display_total": 763.28,
                        "mandatory_fee_details": {
                            "source_currency": "USD",
                            "source_total": 293.65,
                            "display_currency": "CAD",
                            "display_total": 398.38,
                            "breakdown": {
                                "prepaid": {
                                    "source_currency": "USD",
                                    "source_total": 0,
                                    "display_currency": "CAD",
                                    "display_total": 0,
                                    "breakdown": []
                                },
                                "postpaid": {
                                    "source_currency": "USD",
                                    "source_total": 293.65,
                                    "display_currency": "CAD",
                                    "display_total": 398.38,
                                    "breakdown": [
                                        {
                                            "type": "Resort Fee",
                                            "is_prepaid": 0,
                                            "description": "$293.65 USD per room per stay",
                                            "source_currency": "USD",
                                            "source_total": 293.65,
                                            "display_currency": "CAD",
                                            "display_total": 398.38
                                        }
                                    ]
                                }
                            }
                        },
                        "night_price_data": [
                            {
                                "source_night_price": "70.69",
                                "display_night_price": "95.90",
                                "baseline_night_price": "70.69"
                            },
                            {
                                "source_night_price": "70.69",
                                "display_night_price": "95.90",
                                "baseline_night_price": "70.69"
                            },
                            {
                                "source_night_price": "70.69",
                                "display_night_price": "95.90",
                                "baseline_night_price": "70.69"
                            },
                            {
                                "source_night_price": "70.69",
                                "display_night_price": "95.90",
                                "baseline_night_price": "70.69"
                            },
                            {
                                "source_night_price": "70.69",
                                "display_night_price": "95.90",
                                "baseline_night_price": "70.69"
                            },
                            {
                                "source_night_price": "70.69",
                                "display_night_price": "95.90",
                                "baseline_night_price": "70.69"
                            },
                            {
                                "source_night_price": "70.69",
                                "display_night_price": "95.90",
                                "baseline_night_price": "70.69"
                            }
                        ]
                    },
                    "cancellation_details": [
                        {
                            "description": "Any cancellation received within 3 days prior to arrival date will incur the first night charge. Failure to arrive at your hotel or property will be treated as a No-Show and will incur the first night charge (Property policy).",
                            "date_after": "2016-10-19T17:00:00-07:00",
                            "date_before": "2020-07-13T00:00:00-07:00",
                            "penalty_nights": 0,
                            "source_currency": "USD",
                            "source_amount": 0,
                            "source_tax": 0,
                            "source_processing_fee": 0,
                            "source_cancellation_fee": 0,
                            "source_refund": 562.62,
                            "source_total_charges": 0,
                            "display_currency": "CAD",
                            "display_amount": 0,
                            "display_tax": 0,
                            "display_processing_fee": 0,
                            "display_cancellation_fee": 0,
                            "display_refund": 763.28,
                            "display_total_charges": 0
                        },
                        {
                            "description": "After 13/Jul/2020, 12:00 AM (America/Los Angeles) you are not allowed to change or cancel your reservation. If you cancel your room, you will still be charged for the full reservation amount.",
                            "date_after": "2020-07-13T00:00:00-07:00",
                            "date_before": "2024-04-11T07:00:00-07:00",
                            "penalty_nights": 7,
                            "source_currency": "USD",
                            "source_amount": 562.62,
                            "source_tax": 0,
                            "source_processing_fee": 0,
                            "source_cancellation_fee": 0,
                            "source_refund": 0,
                            "source_total_charges": 562.62,
                            "display_currency": "CAD",
                            "display_amount": 763.28,
                            "display_tax": 0,
                            "display_processing_fee": 0,
                            "display_cancellation_fee": 0,
                            "display_refund": 0,
                            "display_total_charges": 763.28
                        }
                    ],
                    "policy_data": {
                        "cancel_policy_description": "Any cancellation received within 3 days prior to arrival date will incur the first night charge. Failure to arrive at your hotel or property will be treated as a No-Show and will incur the first night charge (Property policy).",
                        "is_cancellable": "true"
                    },
                    "plugin_data": null,
                    "promo_data": [],
                    "upsell_data": null,
                    "is_cancellable": "true",
                    "cvc_required": true
                }
            ]
        }
    ]
  }
}

const mutations = {
    updateAvailResponse (state, result) {
      state.availResponse[result.offer.offerToken] = result;
    }
}

const getters = {
  getAvailResponse: state => offerToken => state.availResponse[offerToken],
  getSampleHotelData: state => state.sampleHotelData
}

const actions = {
    updateAvailResponse (context, result) {
        context.commit('updateAvailResponse', result);
    }
}

export default {
  state,
  mutations,
  getters,
  actions
}